Hop.defineModule('comatch-email-check', (root, param) => {
    if (!param.activated) {
        return function destroy() {};
    }

    const emailInput = root.querySelector(param.emailInputId);
    const submitButton = root.querySelector(param.submitButtonId);
    const lpMessage = root.querySelector(param.lpMessageId);

    const hostHead = document.querySelector('head');
    const css = document.createElement('style');
    const content = document.createTextNode(`
        .comatch-blocked .hide-if-blocked {
            display: none;
        }
    `);
    css.appendChild(content);
    hostHead.appendChild(css);

    const debounceCheckForComatchImportedUser = Hop.debounce(checkForComatchImportedUser, 100);

    const LP_HREF = '/c/comatch/hello';

    let lpMessageDisplayed = false;

    function buildHref() {
        return LP_HREF + '?email=' + encodeURIComponent(emailInput.value.trim());
    }

    function setupEventListeners() {
        emailInput.addEventListener('input', debounceCheckForComatchImportedUser);
        emailInput.addEventListener('focusout', checkForComatchImportedUser);
        emailInput.addEventListener('keypress', goToLpOnEnterKeyPressIfNecessary);
    }

    function removeEventListeners() {
        emailInput.removeEventListener('input', debounceCheckForComatchImportedUser);
        emailInput.removeEventListener('focusout', checkForComatchImportedUser);
        emailInput.removeEventListener('keypress', goToLpOnEnterKeyPressIfNecessary);
    }

    function goToLpOnEnterKeyPressIfNecessary(event) {
        if (!lpMessageDisplayed || !(event.which === 13 || event.keyCode === 13)) {
            return;
        }

        event.preventDefault();
        window.location.href = buildHref();
    }

    function showLpMessage() {
        submitButton.setAttribute('disabled', '');
        root.classList.add('comatch-blocked');

        lpMessage.classList.remove('hidden');
        const lpLink = lpMessage.querySelector('a');
        lpLink.href = buildHref();

        lpMessageDisplayed = true;
    }

    function showSubmitButton() {
        submitButton.removeAttribute('disabled');
        root.classList.remove('comatch-blocked');

        lpMessage.classList.add('hidden');

        lpMessageDisplayed = false;
    }

    function checkForComatchImportedUser() {
        if (!emailInput.value || !emailInput.value.trim()) {
            showSubmitButton();
            return;
        }

        const emailAddress = emailInput.value.trim();
        const simpleEmailRegex = /.+@.+\..+/;
        if (!simpleEmailRegex.test(emailAddress)) {
            return;
        }

        fetch('/api/comatch/account', {
            method: 'POST',
            body: JSON.stringify({email: emailAddress}),
            headers: {'Content-Type': 'application/json'},
        })
            .then((response) => response.status === 200 && response.json())
            .then((data) => (!data || data.isActivated ? showSubmitButton() : showLpMessage()));
    }

    setupEventListeners();
    checkForComatchImportedUser();

    return function destroy() {
        removeEventListeners();
    };
});
